<template>
  <transition name="bee-zoom-in-top">
    <div
      v-show="showPopper"
      class="bee-popper bee-autocomplete-suggestion"
      >
      <ul>
         <slot></slot>
      </ul>
      <!-- <bee-scrollbar
        tag="ul"
        wrap-class="el-autocomplete-suggestion__wrap"
        view-class="el-autocomplete-suggestion__list">
        <slot></slot>
      </bee-scrollbar> -->
    </div>
  </transition>
</template>

<script>
import Popper from '../../utils/vue-popper'
import Emitter from '../../utils/emitter'
// import BeeScrollbar from '../scrollbar'

export default {
  name: 'BeeAutocompleteSuggestion',
  mixins: [Popper, Emitter],
  props: {

  },
  data() {
    return {
      parent: this.$parent
    }
  },
  computed: {

  },
  components: {
    // BeeScrollbar
  },
  watch: {

  },
  methods: {
    select(item) {
      this.dispatch('BeeAutocomplete', 'item-click', item)
    }
  },
  updated() {
    this.$nextTick(() => {
      this.popperJS && this.updatePopper()
    })
  },
  created() {
    this.$on('visible', (val) => {
      this.showPopper = val
    })
  },
  mounted() {
    this.popperElm = this.$el
    this.referenceElm = this.$parent.$refs.input.$refs.input
  }
}
</script>



// WEBPACK FOOTER //
// src/components/autocomplete/autocomplete-suggestion.vue